<template>
  <b-card-code title="Proses Yang Telah dilalui">
    <app-timeline>
      <app-timeline-item
        v-for="(item, key) in timelineData"
        :key="key"
        :title="key"
        :subtitle="item.message"
        :time="item.durasi"
        :variant="item.status ? 'success' : 'warning'"
      />

    </app-timeline>
  </b-card-code>
</template>


<script>
import BCardCode from '@core/components/b-card-code'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import {
  getStatus,
} from '@/connection-api/lembarkehidupan'

export default {
  components: {
    BCardCode,
    AppTimeline,
    AppTimelineItem,
  },
  data() {
    return {
      timelineData: {},
    }
  },
  async mounted() {
    // Fetch the JSON data and assign it to timelineData
    try {
      const response = await getStatus();
      this.timelineData = response.data.data;
    } catch (error) {
      console.error(error);
    }
  },
}
</script>
